<template>
    <div class="setcourse">
      <!-- 工具栏 -->
      <h3>
          <span class="button_self_menu" @click="saveMenu()">{{$t('personSet.save')}}</span>
          <span class="button_self_menu" @click="toggleAllFlag(!allFlg)">{{allFlg ? $t('new.title11') : $t('new.title10')}}</span>
          <span class="back button_self_menu btn-back" @click="back()"><em>{{$t('common.returnButton')}}</em></span>
          <div class="title_self_menu">{{$t('new.title2')}}</div>
      </h3>

      <!-- 菜单列表 -->
      <div class="setcourse-list">
          <ul>
              <li v-for="(item, index) in menu" :key="index">
                  <p class="title">{{item.name}}</p>
                  <span class="menu-switch" :class="{'menu-switch-on': item.flag}" :value="item.flag" @click="toggle(index, !item.flag)"></span>
              </li>
          </ul>
      </div>
    </div>
</template>

<script>
    import { mapActions } from "vuex";
    export default {
        name: "scheduleSetSelfMenu",
        data() {
            return {
                menu: [],
                isPcflag: 0,
                fromPagetype: 2
            };
        },
        created() {
            // 加载组件时获取菜单信息
            this.getMenu();
        },
        computed: {
            // 菜单中改变状态时自动切换ALL状态
            allFlg() {
                let result = this.menu.filter((item) => item.flag == true);
                let flg = result.length == this.menu.length ? true : false;
                return flg;
            },
        },
        methods: {
            // 按语言获取菜单列表
            getMenu: function () {
                this.$api
                    .post("/pullDownMenu/scheduleMenuState", {
                        language: this.$lang(),
                        flag: this.isPcflag,
                        type: this.fromPagetype,
                    })
                    .then((response) => {
                        this.menu = response.data;
                    });
            },

            // 更改每个项目的状态
            toggle: function (index, flag) {
                this.menu[index].flag = flag;
            },

            // 保存设置状态
            saveMenu: function () {
            
              // 删除站点的保存数据 - 我的课程
              this.scheduleResetDataCourse();
             
              // Lấy userID
              let userId = this.$attrs.userId || window.sessionStorage.getItem("id");               
              if (this.allFlg) {
                // 显示所有
                this.savveAll();

              } else {

                // Setting dữ liệu
                let data = this.menu.reduce((acc, curr) => {
                    if (!curr.flag) {
                      curr.flag = this.isPcflag;
                      curr['type'] = this.fromPagetype;
                      curr['tagId'] = curr.id;
                      curr['userId'] = userId;
                      acc.push(curr);
                    }
                    return acc;
                }, []);

                
                // Hiển thị theo setting
                this.savveByTagID(data);
              }
            },

            // 保存状态 显示全部
            savveAll: function () {
              this.$api
              .post("/pullDownMenu/saveUserTagsNull", {
                  flag: this.isPcflag,
                  type: this.fromPagetype,
              })
              .then(() => {
                  // Thông báo thành công
                  this.$message({
                      type: 'success',
                      message: this.$t("js.saveSuccess")
                  });

                  this.initSchedule({ tagID: null, language: this.$lang(), name: this.$t("schoolBusiness.all") });
              });
            },

            // 保存要隐藏的项目
            savveByTagID: function (data) {
              this.$api.post("/pullDownMenu/saveUserTags", data).then(() => {
                  // Thông báo thành công
                  this.$message({
                      type: 'success',
                      message: this.$t("js.saveSuccess")
                  });

                  this.initSchedule({ tagID: null, language: this.$lang(), name: this.$t("schoolBusiness.all") });
              });
            },

            // 状态转换 ALL
            toggleAllFlag: function (flag) {
                let newMenu = this.menu.reduce((acc, curr) => {
                    curr.flag = flag;
                    acc.push(curr);
                    return acc;
                }, []);
                this.menu = newMenu;
            },

            // Trở về lại trang -  Khóa học của tôi
            back: function () {
                if (this.checkGeneralEnvironment() == 4 || this.checkGeneralEnvironment() == 0) {
                    if (this.$route.query.isMoreCourse) {
                        this.$router.push("/home/moreCourses")
                    } else {
                        this.$router.push("/home/SchoolBusiness_new")
                    }
                } else {
                    this.$router.push("/home/scheduleSchoolBusiness")
                }
            },

            // Khai báo hàm trong vuex
            ...mapActions("schoolBussiness", ["initSchedule", "scheduleResetDataCourse"]),
        },
    };
</script>

<style scoped>
    .setcourse {
        width: 800px;
        margin: 0 auto;
        padding-top: 100px;
    }
    .setcourse h3 {
        font-size: 24px;
        padding: 10px 0;
        border-bottom: 1px solid #ccc;
    }
    .setcourse h3 span {
        background-image: -webkit-linear-gradient(315deg, #02adff 0%, #00d3ff 100%);
        background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
        font-size: 14px;
        float: right;
        font-weight: normal;
        color: #fff;
        padding: 5px 10px;
        border-radius: 5px;
        margin-right: 10px;
        cursor: pointer;
    }
    .setcourse h3 span.back {
        background-image: -webkit-linear-gradient(315deg, #888 0%, #ccc 100%);
        background-image: linear-gradient(135deg, #888 0%, #ccc 100%);
    }
    .setcourse li {
        padding: 20px 0;
        border-bottom: 1px dotted #ccc;
        font-size: 16px;
    }
    .setcourse li p {
        display: inline-block;
    }
    .setcourse li span {
        float: right;
        margin-right: 10px;
    }
    .menu-switch {
        display: block;
        position: relative;
        width: 46px;
        height: 26px;
        border: 1px solid #dfdfdf;
        outline: 0;
        border-radius: 16px;
        box-sizing: border-box;
        background-color: #dfdfdf;
        transition: background-color 0.1s, border 0.1s;
        cursor: pointer;
    }
    .menu-switch:before {
        content: " ";
        position: absolute;
        top: 0;
        left: 0;
        width: 44px;
        height: 24px;
        border-radius: 15px;
        background-color: #fdfdfd;
        transition: transform 0.35s cubic-bezier(0.45, 1, 0.4, 1);
    }
    .menu-switch:after {
        content: " ";
        position: absolute;
        top: 0;
        left: 0;
        width: 24px;
        height: 24px;
        border-radius: 15px;
        background-color: #ffffff;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
        transition: transform 0.35s cubic-bezier(0.4, 0.4, 0.25, 1.35);
    }
    .menu-switch-on {
        border-color: #79c9ff;
        background-color: #79c9ff;
    }
    .menu-switch-on:before {
        border-color: #79c9ff;
        background-color: #79c9ff;
    }
    .menu-switch-on:after {
        transform: translateX(20px);
    }
    @media screen and (max-width: 950px) {
        .setcourse {
            width: calc(100% - 60px);
            margin: 0 auto;
            padding-top: 25px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/schedule/scheduleSetSelfMenu.vue